import getUrlPath from '../../utils/getUrlPath';
import PrivateRoute from '../../components/route/PrivateRoute';
import React, { Suspense } from 'react';
import { PaymentApplicationSource } from "@app/types/payment-account/general";
import { Route, Routes } from 'react-router-dom';
import { url } from '../../constants/url';

const CheckoutRoutes = React.lazy(() => import('./checkout/CheckoutRoutes'));
const DashboardRoutes = React.lazy(() => import('./dashboard/DashboardRoutes'));
const SignUpRoute = React.lazy(() => import('./signup/SignUpRoute'));
const ApplyCredit = React.lazy(
  () => import('../../page-fragments/payment-account/apply-account/ApplyAccount'),
);

function AuxiliaryRouter() {
  return (
    <Routes>
      <Route
        path={url.account.path + '/*'}
        element={
          <Suspense fallback={null}>
            <PrivateRoute component={<DashboardRoutes />} />
          </Suspense>
        }
      />
      <Route
        path={url.signup.path + '/*'}
        element={
          <Suspense fallback={null}>
            <SignUpRoute />
          </Suspense>
        }
      />
      <Route
        path={getUrlPath(url.rental.subPath.cart)}
        element={
          <Suspense fallback={null}>
            <CheckoutRoutes path={getUrlPath(url.rental.subPath.cart) ?? ''} />
          </Suspense>
        }
      />
      <Route
        path={getUrlPath(url.rental.subPath.checkout)}
        element={
          <Suspense fallback={null}>
            <CheckoutRoutes path={getUrlPath(url.rental.subPath.checkout) ?? ''} />
          </Suspense>
        }
      />
      <Route
        path={getUrlPath(url.rental.subPath.orderDetails)}
        element={
          <Suspense fallback={null}>
            <CheckoutRoutes path={getUrlPath(url.rental.subPath.orderDetails) ?? ''} />
          </Suspense>
        }
      />
      <Route
        path={getUrlPath(url.applyCredit)}
        element={
          <Suspense fallback={null}>
            <ApplyCredit source={PaymentApplicationSource.GUEST_USER} />
          </Suspense>
        }
      />
    </Routes>
  );
}

export default AuxiliaryRouter;
